import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import CursorAccent from "@/components/CursorAccent";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-brand-bg">
      <SmoothScroll />
      <CursorAccent />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
